import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CacheService {
    
    // The 'set' method for storing data in the cache.
    set(key: string, data: any): void {
        localStorage.setItem(key, JSON.stringify(data));
    }

    // The 'get' method for retrieving data from the cache.
    get(key: string): any {
        // We retrieve the data from the cache and update the BehaviorSubject.
        let data = localStorage.getItem(key)
        return (data) ? JSON.parse(data) as any : null;
        //return  data && JSON.parse(data);
    }

    // The 'clear' method to clear data from the cache.
    clear(key: string): void {
        // We remove the data from the cache and update the BehaviorSubject.
        localStorage.removeItem(key.toString());
    }
}